import { useController, useFormContext } from "react-hook-form";

import Textarea from "./base";

interface ControlledTextareaProps extends React.ComponentProps<
  typeof Textarea
> {
  rules?: {
    required?: { value: boolean; message: string };
    minLength?: { value: number; message: string };
    maxLength?: { value: number; message: string };
    validate?: (val: string) => string | undefined;
    pattern?: { value: RegExp; message: string };
  };
}

export function ControlledTextarea({
  name,
  placeholder,
  info = "",
  label = "",
  rules = {},
  autoComplete = "on",
  rows = 4,
}: ControlledTextareaProps) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name, control, rules });
  const required = rules.required?.value === true;

  return (
    <Textarea
      label={label}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      name={field.name}
      disabled={field.disabled}
      inputRef={field.ref}
      error={fieldState.error?.message}
      required={required}
      autoComplete={autoComplete}
      placeholder={placeholder}
      info={info || ""}
      rows={rows}
    />
  );
}
